module.exports = __webpack_public_path__ + "img/zongping.55be7e78.jpg";